import React from 'react';
import { connect } from 'react-redux';
import '../src/leaseKeys.scss';
import actions from '../actions';
import KeyItem from './KeyItem';
import NewKeyItem from './NewKeyItem';
import LostKey from './LostKey';

const mapStateToProps = state => {
  return {
    abloyKeys: state.abloyKeys,
    givenKeys: state.givenKeys,
    lostKeys : state.lostKeys,
    brokenKeys : state.brokenKeys
  }
};

const mapDispatchToProps = dispatch => ({
  fetchAbloyKeys: (leaseId) => dispatch(actions.fetchAbloyKeys(leaseId)),
  fetchGivenKeys: (keys) => dispatch(actions.fetchGivenKeys(keys)),
  fetchLostKeys: (keys) => dispatch(actions.fetchLostKeys(keys)),
  fetchBrokenKeys: (keys) => dispatch(actions.fetchBrokenKeys(keys)),
});

class LeaseKeys extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inited: false,
      title: 'Avaimet',
    }
  }

  componentDidMount() {
    this.props.fetchGivenKeys(this.props.keys);
    this.props.fetchLostKeys(this.props.lostkeys);
    this.props.fetchBrokenKeys(this.props.brokenkeys);
    this.props.fetchAbloyKeys(this.props.lease.id).then(()=>{
      this.setState({inited: true})
    })
  }

  street() {
    return this.props.lease.apartment ? this.props.lease.apartment.short_address || '' : ''
  }

  customer() {
    const customers = this.props.lease.primary_customers;
    if (!customers) {
      return ''
    }
    const names = customers.map((customer) => {
      return <div key={customer.id}><a href={("/admin/customers/"+ customer.id)} className="customer-link">{customer.first_name + ' ' + customer.last_name}</a></div>
    });
    return names
  }

  givenKeys() {
    if (!this.props.givenKeys || this.props.givenKeys.length === 0) {return null}

    const self = this;
    return (
      this.props.givenKeys.map((item) => {
        let apartmentKeyOperations = ['remove', 'return', 'loose', 'give_to_customer']
        if (item.state == 'returned') {
          apartmentKeyOperations = ['remove']
        }

        return <KeyItem
          key={'key_stamp_all_' + item.id}
          abloyUpdatingMessageStatus={['HANDED_OUT', 'IN_STOCK']}
          abloyKeyOperations={['remove_or_lost']}
          apartmentKeyOperations={apartmentKeyOperations}
          possibleErrors={['is_busy', 'broken', 'lost']}
          greenStatus={'received'}
          item={item}
          lease={self.props.lease}
          inited={self.state.inited} />
      })
    )
  }

  lostKeys() {
    if (!this.props.lostKeys || this.props.lostKeys.length === 0) {return null}

    return (
      <div className="card-keys card-block">
        <p className="card-label">HÄVINNYT AVAIN</p>
        {this.props.lostKeys.map((item, i) => {
          return <LostKey key={'key_stamp_out_' + i} item={item} />
        })}
      </div>
    );
  }

  brokenKeys() {
    if (!this.props.brokenKeys || this.props.brokenKeys.length === 0) {return null}

    return (
      <div className="card-keys card-block">
        <p className="card-label">Hajonneeksi merkityt avaimet</p>
        {this.props.brokenKeys.map((item, i) => {
          return <LostKey key={'key_stamp_out_' + i} item={item} />
        })}
      </div>
    );
  }

  render() {
    return (
      <div>
        <div className="keys-column">
          {this.givenKeys()}
        </div>
        {/* lost keys */}
        {this.lostKeys()}
        {this.brokenKeys()}
        <div className="keys-row push-top">
          <div className="keys-column">
            <h2 className="t4">Lisää uusi avain</h2>
            <div className="help">
              <p>Lisää avain antamalla sen leima ja painamalla <strong>Lisää avain</strong>. Jos avain on luovutettu asukkaalle valitse <strong>Luovutettu</strong>.</p>
            </div>
          </div>
        </div>
        <div className="keys-row">
          {<NewKeyItem lease={this.props.lease}></NewKeyItem>}
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LeaseKeys)

